export const LIST_ADVISER_CONTACTS_REQUESTED =
  'LIST_ADVISER_CONTACTS_REQUESTED';
export const LIST_ADVISER_CONTACTS_COMPLETED =
  'LIST_ADVISER_CONTACTS_COMPLETED';
export const LIST_ADVISER_CONTACTS_FAILED = 'LIST_ADVISER_CONTACTS_FAILED';
export const LIST_ADVISER_CONTACTS_ABORTED = 'LIST_ADVISER_CONTACTS_ABORTED';

export const SET_ADVISER_CONTACT_REQUESTED = 'SET_ADVISER_CONTACT_REQUESTED';
export const SET_ADVISER_CONTACT_ABORTED = 'SET_ADVISER_CONTACT_ABORTED';
export const SET_ADVISER_CONTACT_COMPLETED = 'SET_ADVISER_CONTACT_COMPLETED';
export const SET_ADVISER_CONTACT_FAILED = 'SET_ADVISER_CONTACT_FAILED';
export const SEARCH_ADVISER_CONTACTS_REQUESTED =
  'SEARCH_ADVISER_CONTACTS_REQUESTED';
export const SEARCH_ADVISER_CONTACTS_COMPLETED =
  'SEARCH_ADVISER_CONTACTS_COMPLETED';
export const SEARCH_ADVISER_CONTACTS_FAILED = 'SEARCH_ADVISER_CONTACTS_FAILED';

// export const GET_USERS_REQUESTED = 'GET_USERS_REQUESTED';
// export const GET_USERS_ABORTED = 'GET_USERS_ABORTED';
// export const GET_USERS_COMPLETED = 'GET_USERS_COMPLETED';
// export const GET_USERS_FAILED = 'GET_USERS_FAILED';
// export const CREATE_USER_REQUESTED = 'CREATE_USER_REQUESTED';
// export const CREATE_USER_ABORTED = 'CREATE_USER_ABORTED';
// export const CREATE_USER_COMPLETED = 'CREATE_USER_COMPLETED';
// export const CREATE_USER_FAILED = 'CREATE_USER_FAILED';

export const RESET_ADVISER_CONTACTS_REQUESTED =
  'RESET_ADVISER_CONTACT_REQUESTED';
export const RESET_ADVISER_CONTACTS_COMPLETED =
  'RESET_ADVISER_CONTACT_COMPLETED';

// export const RESEND_USER_REQUESTED = 'RESEND_USER_REQUESTED';
// export const RESEND_USER_ABORTED = 'RESEND_USER_ABORTED';
// export const RESEND_USER_COMPLETED = 'RESEND_USER_COMPLETED';
// export const RESEND_USER_FAILED = 'RESEND_USER_FAILED';

// export const CHANGE_EMAIL_REQUESTED = 'CHANGE_EMAIL_REQUESTED';
// export const CHANGE_EMAIL_COMPLETED = 'CHANGE_EMAIL_COMPLETED';
// export const CHANGE_EMAIL_FAILED = 'CHANGE_EMAIL_FAILED';
// export const CHANGE_PASSWORD_REQUESTED = 'CHANGE_PASSWORD_REQUESTED';
// export const CHANGE_PASSWORD_COMPLETED = 'CHANGE_PASSWORD_COMPLETED';
// export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';
// export const RESET_TOAST_REQUESTED = 'RESET_TOAST_REQUESTED';
// export const RESET_TOAST_COMPLETED = 'RESET_TOAST_COMPLETED';

// export const DOWNLOAD_CLIENT_USERS_REQUESTED = 'DOWNLOAD_CLIENT_USERS_REQUESTED';
// export const DOWNLOAD_CLIENT_USERS_COMPLETED = 'DOWNLOAD_CLIENT_USERS_COMPLETED';
// export const DOWNLOAD_CLIENT_USERS_FAILED = 'DOWNLOAD_CLIENT_USERS_FAILED';

// export const DOWNLOAD_ADVISER_USERS_REQUESTED = 'DOWNLOAD_ADVISER_USERS_REQUESTED';
// export const DOWNLOAD_ADVISER_USERS_COMPLETED = 'DOWNLOAD_ADVISER_USERS_COMPLETED';
// export const DOWNLOAD_ADVISER_USERS_FAILED = 'DOWNLOAD_ADVISER_USERS_FAILED';
